'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _support = require('helpers/support');

var _SelectList = require('./SelectList');

var _SelectList2 = _interopRequireDefault(_SelectList);

var _SelectCategory = require('./SelectCategory');

var _SelectCategory2 = _interopRequireDefault(_SelectCategory);

var _Expand = require('./Expand');

var _Expand2 = _interopRequireDefault(_Expand);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewFilterMobile = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    if (!(0, _shops.isProminentLoaded)(getState())) {
      promises.push(dispatch((0, _shops.getProminent)()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    districts: state.address.districts
  };
}, (0, _extends3.default)({}, shopActions, addressActions, setupActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(NewFilterMobile, _Component);

  function NewFilterMobile(props) {
    (0, _classCallCheck3.default)(this, NewFilterMobile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NewFilterMobile.__proto__ || (0, _getPrototypeOf2.default)(NewFilterMobile)).call(this, props));

    _this.state = {
      filter: _this.props.filter || [],
      filterActiveTemp: _this.props.filterActive || {},
      showFilter: _this.props.showFilter || false,
      showSubFilter: false
    };

    _this.getFilter = _this.getFilter.bind(_this);
    _this.handleFilter = _this.handleFilter.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    _this.modalClose = _this.modalClose.bind(_this);
    _this.modalNext = _this.modalNext.bind(_this);
    _this.handleCloseFilter = _this.handleCloseFilter.bind(_this);
    _this.setFilter = _this.setFilter.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(NewFilterMobile, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.showFilter !== nextProps.showFilter) {
        this.setState({ showFilter: nextProps.showFilter });
      }
      if (!(0, _lodash.isEqual)(nextProps.filter, this.state.filter)) {
        this.setState({ filter: nextProps.filter });
      }
      if (!(0, _lodash.isEqual)(nextProps.filterActive, this.state.filterActiveTemp)) {
        this.setState({ filterActiveTemp: nextProps.filterActive });
      }
    }
  }, {
    key: 'resetFilter',
    value: function resetFilter() {
      this.setState({
        filterActiveTemp: this.props.filterActive,
        filter: this.props.filter
      });
    }
  }, {
    key: 'handleCloseFilter',
    value: function handleCloseFilter() {
      // Tất cả những gì trong filter là tạm. Do vậy khi không submit, ngoài việc thoát khỏi filter, còn phải RESET LẠI FILTER MẶC ĐỊNH.
      this.resetFilter();
      this.props.closeFilter();
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _state = this.state,
          filter = _state.filter,
          filterActiveTemp = _state.filterActiveTemp;

      this.props.onSubmit(filter, filterActiveTemp);
    }
  }, {
    key: 'modalNext',
    value: function modalNext() {
      this.setState({ showSubFilter: false });
    }
  }, {
    key: 'modalOpen',
    value: function modalOpen(subActive) {
      this.setState({ showSubFilter: true });
      this.subActive = subActive;
    }
  }, {
    key: 'modalClose',
    value: function modalClose() {
      var filterActiveTemp = (0, _extends3.default)({}, this.state.filterActiveTemp);
      filterActiveTemp.subcategory = this.subActive;
      this.setState({ showSubFilter: false, filterActiveTemp: filterActiveTemp });
    }
  }, {
    key: 'getFilter',
    value: function getFilter(key) {
      // input: key (category, subcategory, province,...) => output: {key: ..., type, data}
      var filter = this.state.filter;

      var result = filter.filter(function (v) {
        return v.key === key;
      });
      return result.length ? result[0] : {};
    }
  }, {
    key: 'setFilter',
    value: function setFilter(key, data) {
      // Input key, data (object filter)
      // Set giá trị mới cho filter, vì nó là mảng nên buộc phải for, mảng dùng render theo thứ tự.
      var filter = [].concat((0, _toConsumableArray3.default)(this.state.filter));
      for (var i = 0, len = filter.length; i < len; i++) {
        if (filter[i].key === key) {
          filter[i] = data;
        }
      }
      return filter;
    }
  }, {
    key: 'handleFilter',
    value: function handleFilter(key, item) {
      var _state2 = this.state,
          filterActiveTemp = _state2.filterActiveTemp,
          filter = _state2.filter;

      var newFilter = [].concat((0, _toConsumableArray3.default)(filter));
      var newActive = (0, _extends3.default)({}, filterActiveTemp);
      switch (key) {
        case 'category':
          // Category chỉ được chọn 1. Đổi category phải reset subcategory (bao gồm xóa subActive và dữ liệu sub mới).
          if (newActive[key].indexOf(item.value) === -1) {
            newActive[key] = [item.value];
            newActive.subcategory = [];
            newFilter = this.setFilter('subcategory', _support.syncData.subs(item.value));
          }
          break;
        default:
          if (newActive[key].indexOf(item.value) !== -1) {
            (0, _lodash.pull)(newActive[key], item.value);
          } else {
            newActive[key] = [item.value].concat((0, _toConsumableArray3.default)(newActive[key]));
          }
      }
      this.setState({ filterActiveTemp: newActive, filter: newFilter });
    }
  }, {
    key: 'renderFilter',
    value: function renderFilter(item, i) {
      var _this2 = this;

      var provinceName = this.props.provinceName;

      var active = this.state.filterActiveTemp[item.key];
      switch (item.key) {
        case 'category':
          // const sub = syncData.subs(active[0]) || {};
          var sub = this.getFilter('subcategory');
          var subActive = this.state.filterActiveTemp.subcategory;
          return _react2.default.createElement(
            _Expand2.default,
            { key: 'cat_' + i, title: 'Danh m\u1EE5c', icon: 'tasks' },
            _react2.default.createElement(_SelectCategory2.default, {
              cat: item,
              sub: sub,
              active: active,
              subActive: subActive,
              onClick: this.handleFilter,
              onPlus: function onPlus() {
                return _this2.modalOpen(subActive);
              }
            })
          );
        case 'district':
          return _react2.default.createElement(
            _Expand2.default,
            {
              key: 'dis_' + i,
              title: 'Khu v\u1EF1c',
              flag: provinceName,
              icon: 'map-marker'
            },
            _react2.default.createElement(_SelectList2.default, {
              key: 'select_' + i,
              data: item,
              active: active,
              onClick: this.handleFilter
            })
          );
        default:
          break;
      }
    }
  }, {
    key: 'renderNewSub',
    value: function renderNewSub(sub, i) {
      if (sub.key === 'subcategory') {
        var active = this.state.filterActiveTemp[sub.key];
        return _react2.default.createElement(_SelectList2.default, {
          key: 'select_' + i,
          data: sub,
          active: active,
          onClick: this.handleFilter
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./FilterMobile.scss');
      var filter = this.state.filter;
      var _state3 = this.state,
          showSubFilter = _state3.showSubFilter,
          showFilter = _state3.showFilter;

      return _react2.default.createElement(
        'div',
        { className: styles.pfilter + ' ' + (showFilter ? styles.show : '') },
        _react2.default.createElement(
          'div',
          {
            className: styles.filterDropdown + ' ' + (showFilter ? styles.show : '')
          },
          _react2.default.createElement('div', { className: styles.mysteryborder }),
          _react2.default.createElement(
            'div',
            { className: styles.filterHeader },
            _react2.default.createElement('div', {
              className: styles.close,
              onClick: this.handleCloseFilter
            }),
            _react2.default.createElement(
              'div',
              { className: styles.btnSubmit, onClick: this.onSubmit },
              '\xC1p D\u1EE5ng'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.filterContent },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              'B\u1ED9 l\u1ECDc'
            ),
            filter && filter.length && filter.map(function (v, i) {
              return _this3.renderFilter(v, i);
            })
          )
        ),
        _react2.default.createElement(
          'div',
          {
            className: styles.filterDropdown + ' ' + styles.subFilter + ' ' + (showSubFilter ? styles.show : '')
          },
          _react2.default.createElement(
            'div',
            { className: styles.filterHeader },
            _react2.default.createElement(
              'div',
              { className: styles.back, onClick: this.modalClose },
              'back'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.btnSubmit, onClick: this.modalNext },
              'next'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.filterContent },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              'B\u1ED9 l\u1ECDc'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.subBox + ' ' + styles.expand },
              filter && filter.length && filter.map(function (v, i) {
                return _this3.renderNewSub(v, i);
              })
            )
          )
        )
      );
    }
  }]);
  return NewFilterMobile;
}(_react.Component), _class2.propTypes = {
  districts: _react.PropTypes.array,
  closeFilter: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func,
  showFilter: _react.PropTypes.bool,
  filter: _react.PropTypes.array,
  filterActive: _react.PropTypes.object,
  provinceName: _react.PropTypes.string
}, _temp)) || _class) || _class);
exports.default = NewFilterMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/CategoryMobile/NewFilterMobile.js
// module id = 1545
// module chunks = 0